module.exports = __webpack_public_path__ + "static/media/lb.bc789b21.svg";